(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}
parcelRequire.register("juqrk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e3055412a69a0bec$export$2996f80ef42b8419; });
function $e3055412a69a0bec$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRequire.register("bNI6E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $89767be5ae191d10$export$d60067ff2358eee8; });
function $89767be5ae191d10$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $89767be5ae191d10$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $89767be5ae191d10$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $89767be5ae191d10$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRequire.register("fGQt0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b6c37a1b08cb752d$export$fdf2a89c76341bbf; });

var $jPS0G = parcelRequire("jPS0G");

var $iQVao = parcelRequire("iQVao");

var $2TBLM = parcelRequire("2TBLM");

var $avvGs = parcelRequire("avvGs");
function $b6c37a1b08cb752d$export$fdf2a89c76341bbf(arr, i) {
    return (0, $jPS0G._array_with_holes)(arr) || (0, $iQVao._iterable_to_array_limit)(arr, i) || (0, $avvGs._unsupported_iterable_to_array)(arr, i) || (0, $2TBLM._non_iterable_rest)();
}

});
parcelRequire.register("jPS0G", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $e70cad04b84cd1c0$export$e6256bf45c68d561; });
function $e70cad04b84cd1c0$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRequire.register("iQVao", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $db996d728bd6bdbf$export$2fd15edff6687200; });
function $db996d728bd6bdbf$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRequire.register("2TBLM", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $21be0414e7551937$export$60dbc22abd7da546; });
function $21be0414e7551937$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRequire.register("avvGs", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $7a656066cb9fb4bf$export$a5be06335b3a083c; });

var $gLGHe = parcelRequire("gLGHe");
function $7a656066cb9fb4bf$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gLGHe._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gLGHe._array_like_to_array)(o, minLen);
}

});
parcelRequire.register("gLGHe", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $c35227b66bb73462$export$79e617b1955a2616; });
function $c35227b66bb73462$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRequire.register("aYXpI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7fed984c591c61d1$export$1b5e630bc3aea29f; });

var $8FgSx = parcelRequire("8FgSx");

var $jSYmc = parcelRequire("jSYmc");

var $6TTBR = parcelRequire("6TTBR");

var $avvGs = parcelRequire("avvGs");
function $7fed984c591c61d1$export$1b5e630bc3aea29f(arr) {
    return (0, $8FgSx._array_without_holes)(arr) || (0, $jSYmc._iterable_to_array)(arr) || (0, $avvGs._unsupported_iterable_to_array)(arr) || (0, $6TTBR._non_iterable_spread)();
}

});
parcelRequire.register("8FgSx", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $64ef3ecb073cf3d1$export$7e0947b5ad3404e2; });

var $gLGHe = parcelRequire("gLGHe");
function $64ef3ecb073cf3d1$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $gLGHe._array_like_to_array)(arr);
}

});

parcelRequire.register("jSYmc", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $e7a1e1249a38f823$export$1eb58a6e75231000; });
function $e7a1e1249a38f823$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRequire.register("6TTBR", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $5063040d55f66da2$export$e6f3c4780d19eb2b; });
function $5063040d55f66da2$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRequire.register("iSEZc", function(module, exports) {
var $dbed101c91af2533$var$toggleTheme = document.querySelector('.theme-switch input[type="checkbox"]');
var $dbed101c91af2533$var$storageTheme = localStorage.getItem("theme");
var $dbed101c91af2533$var$theme = {
    LIGHT: "light",
    DARK: "dark"
};
if ($dbed101c91af2533$var$storageTheme) {
    document.documentElement.setAttribute("data-theme", $dbed101c91af2533$var$storageTheme);
    if ($dbed101c91af2533$var$storageTheme === $dbed101c91af2533$var$theme.DARK) $dbed101c91af2533$var$toggleTheme.checked = true;
}
function $dbed101c91af2533$var$setTheme(el) {
    if (el.target.checked) {
        document.documentElement.setAttribute("data-theme", $dbed101c91af2533$var$theme.DARK);
        localStorage.setItem("theme", $dbed101c91af2533$var$theme.DARK);
    } else {
        document.documentElement.setAttribute("data-theme", $dbed101c91af2533$var$theme.LIGHT);
        localStorage.setItem("theme", $dbed101c91af2533$var$theme.LIGHT);
    }
}
$dbed101c91af2533$var$toggleTheme.addEventListener("change", $dbed101c91af2533$var$setTheme, false);

});

parcelRequire.register("60vED", function(module, exports) {

$parcel$export(module.exports, "team", function () { return $45fb4c0fc3ae76d3$export$8d64293bd263e87; });

var $lQFyQ = parcelRequire("lQFyQ");

var $gyhTO = parcelRequire("gyhTO");

var $cQvWE = parcelRequire("cQvWE");

var $cBqGa = parcelRequire("cBqGa");

var $3NGoN = parcelRequire("3NGoN");

var $3py74 = parcelRequire("3py74");

var $5woDj = parcelRequire("5woDj");

var $7wXd0 = parcelRequire("7wXd0");

var $5ISYP = parcelRequire("5ISYP");

var $7gwRX = parcelRequire("7gwRX");

var $jqSZK = parcelRequire("jqSZK");
var $45fb4c0fc3ae76d3$export$8d64293bd263e87 = [
    {
        name: "Yaroslav Matvieiev",
        position: "Team Lead, Developer",
        // description: 'JS, HTML, SCSS',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($lQFyQ))),
        url: "https://github.com/yaromatv"
    },
    {
        name: "Denys Lavryk",
        position: "Scrum Master, Developer",
        // description: 'JS, HTML, SCSS',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($gyhTO))),
        url: "https://github.com/strictly-rigid"
    },
    {
        name: "Anastasiia Vedmid",
        position: "Developer",
        // description: 'JS, HTML, SCSS',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($cQvWE))),
        url: "https://github.com/neyonse"
    },
    {
        name: "Maryna Sihida",
        position: "Developer",
        // description: 'JS, HTML, SCSS',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($cBqGa))),
        url: "https://github.com/marinasigida"
    },
    {
        name: "Vitalii Duduka",
        position: "Developer",
        // description: 'JS, HTML, SCSS',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($3NGoN))),
        url: "https://github.com/VitaliiDuduka"
    },
    {
        name: "Mary Kuzo",
        position: "Developer",
        // description: 'JS, HTML, SCSS',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($3py74))),
        url: "https://github.com/marykuzo"
    },
    {
        name: "Oleksii Burlaka",
        position: "Developer",
        // description: 'JS, HTML, SCSS',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($5woDj))),
        url: "https://github.com/Oleksii001"
    },
    {
        name: "Victory Krasova",
        position: "Developer",
        // description: 'JS, HTML, SCSS',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($7wXd0))),
        url: "https://github.com/VictoryKrasova"
    },
    {
        name: "Artem Zaitsev",
        position: "Developer",
        // description: 'JS, HTML, SCSS',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($5ISYP))),
        url: "https://github.com/Artemzaicew"
    },
    {
        name: "Oleksii Khodarchenko",
        position: "Developer",
        // description: 'JS, HTML, SCSS',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($7gwRX))),
        url: "https://github.com/oleksii3339"
    },
    {
        name: "Oleg Kryuchkov",
        position: "Developer",
        // description: 'JS, HTML, SCSS',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($jqSZK))),
        url: "https://github.com/OlegKryuchkov"
    }
];

});
parcelRequire.register("lQFyQ", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("8lVdV");

});
parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});


parcelRequire.register("gyhTO", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("dvJIi");

});

parcelRequire.register("cQvWE", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("28vT0");

});

parcelRequire.register("cBqGa", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("htewY");

});

parcelRequire.register("3NGoN", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("f6ubB");

});

parcelRequire.register("3py74", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("4PEBw");

});

parcelRequire.register("5woDj", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("aqM5A");

});

parcelRequire.register("7wXd0", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("kuloD");

});

parcelRequire.register("5ISYP", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("FsH2z");

});

parcelRequire.register("7gwRX", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("cSrA0");

});

parcelRequire.register("jqSZK", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("6wAZj");

});


parcelRequire.register("ghnK3", function(module, exports) {

var $60vED = parcelRequire("60vED");
// import svgGithubUrl from '../images/team/icon-github.svg';
// import svgGithubUrl from '../images/sprite.svg#icon-github';
var $030efa6d71473853$var$openModalTeamLink = document.querySelector(".footer-link");
var $030efa6d71473853$var$closeModalTeamBtn = document.querySelector(".modal-team__close-btn");
var $030efa6d71473853$var$modalTeam = document.querySelector("[data-modal-team]");
var $030efa6d71473853$var$teamList = document.querySelector(".modal-team__list");
$030efa6d71473853$var$createMarkupTeam();
$030efa6d71473853$var$openModalTeamLink.addEventListener("click", $030efa6d71473853$var$onClickModalTeam);
$030efa6d71473853$var$closeModalTeamBtn.addEventListener("click", $030efa6d71473853$var$onCloseModalTeam);
// document.body.addEventListener('keyup', onKeyCloseModalTeam, false);
function $030efa6d71473853$var$onClickModalTeam(evt) {
    evt.preventDefault();
    document.body.classList.add("modal-team-open");
    $030efa6d71473853$var$modalTeam.classList.remove("backdrop-team--hidden");
    window.addEventListener("keyup", $030efa6d71473853$var$onKeyUp);
}
function $030efa6d71473853$var$onCloseModalTeam(evt) {
    evt.preventDefault();
    $030efa6d71473853$var$closeModalTeam();
}
function $030efa6d71473853$var$createMarkupTeam() {
    var markup = (0, $60vED.team).map(function(param) {
        var name = param.name, img = param.img, position = param.position, url = param.url;
        return '<li class="modal-team__item">\n  <div class="modal-team__img-container">\n    <a target="_blank" href="'.concat(url, '">\n      <img class="modal-team__img" src="').concat(img, '" alt="').concat(name, '" width="150" height="150">\n    </a>\n      <h3 class="modal-team__title">').concat(name, '</h3>\n  <span class="modal-team__position">').concat(position, "</span>\n  </div>\n</li>");
    }).join("");
    $030efa6d71473853$var$teamList.insertAdjacentHTML("beforeend", markup);
}
$030efa6d71473853$var$modalTeam.addEventListener("click", $030efa6d71473853$var$onBackdropClick);
function $030efa6d71473853$var$onBackdropClick(e) {
    if (e.target.classList.contains("backdrop-team")) $030efa6d71473853$var$closeModalTeam();
}
function $030efa6d71473853$var$onKeyUp(param) {
    var code = param.code;
    if (code === "Escape") $030efa6d71473853$var$closeModalTeam();
}
function $030efa6d71473853$var$closeModalTeam() {
    $030efa6d71473853$var$modalTeam.classList.add("backdrop-team--hidden");
    document.body.classList.remove("modal-team-open");
    window.removeEventListener("keyup", $030efa6d71473853$var$onKeyUp);
} // `<li class="modal-team__item">
 //   <div class="modal-team__img-container">
 //       <img class="modal-team__img" src="${img}" alt="${name}" width="150" height="150">
 //       <a class="modal-team__link-github" target="_blank" href="${url}">
 //               <svg class="modal-team__icon-github" width="24" height="24">
 //               <use href="/src/images/team/icon-github.svg"></use>
 //           </svg></a>
 //   </div>
 //   <h3 class="modal-team__title">${name}</h3>
 //   <span class="modal-team__position">${position}</span>
 // </li>`;

});

parcelRequire.register("i8Q71", function(module, exports) {
// !!!!!!!!!!!!!              Hilighting of current pages         !!!!!!!!!!!!!!!!!!
var $d35165bd5db5382a$var$navHreffsArr = document.querySelectorAll(".js-link");
$d35165bd5db5382a$var$navHreffsArr.forEach(function(navLink) {
    if (navLink.href === navLink.baseURI) navLink.classList.add("current");
    else navLink.classList.remove("current");
});
// !!!!!!!!!!!!!!!           close-btn in burger-menu          !!!!!!!!!!!!!!!!!!!
document.addEventListener("DOMContentLoaded", function() {
    var mobileMenuToggle = document.querySelector(".js-mobile-menu-toggle");
    var mobileMenuClose = document.querySelector(".js-close-menu");
    mobileMenuToggle.addEventListener("click", function() {
        mobileMenuClose.classList.toggle("show");
    });
    mobileMenuClose.addEventListener("click", function() {
        mobileMenuClose.classList.remove("show");
    });
    mobileMenuToggle.addEventListener("click", function() {
        mobileMenuToggle.classList.add("hidden");
        mobileMenuClose.classList.remove("hidden");
    });
    mobileMenuClose.addEventListener("click", function() {
        mobileMenuClose.classList.add("hidden");
        mobileMenuToggle.classList.remove("hidden");
    });
});
// !!!!!!!!!!!!!!!!!!!!!!!          BURGER MENU                !!!!!!!!!!!!!!!!!!!!!!!!!!
(function() {
    var mobileMenu = document.querySelector(".js-menu-container");
    var openMenuBtn = document.querySelector(".js-open-menu");
    var closeMenuBtn = document.querySelector(".js-close-menu");
    var toggleMenu = function() {
        var isMenuOpen = openMenuBtn.getAttribute("aria-expanded") === "true" || false;
        mobileMenu.classList.toggle("is-open");
    };
    openMenuBtn.addEventListener("click", toggleMenu);
    closeMenuBtn.addEventListener("click", toggleMenu);
    // Close the mobile menu on wider screens if the device orientation changes
    window.matchMedia("(min-width: 768px)").addEventListener("change", function(e) {
        if (!e.matches) return;
        mobileMenu.classList.remove("is-open");
        openMenuBtn.setAttribute("aria-expanded", false);
    });
})();

});

parcelRequire.register("18VO4", function(module, exports) {
parcelRequire("1FCkY");
var $aPlzd = parcelRequire("aPlzd");

var $aqSZJ = parcelRequire("aqSZJ");
var $0d5360f8679c38dc$var$supportUkraineList = document.querySelector(".fund-list");
function $0d5360f8679c38dc$var$createFundMarkup(fundList) {
    var isRetina = window.devicePixelRatio > 1.1;
    return fundList.map(function(param) {
        var title = param.title, url = param.url, img = param.img, retinaImg = param.retinaImg;
        var fundImage = isRetina ? retinaImg : img;
        return '\n    <li class="fund swiper-slide">\n    <a class="fund-link" href='.concat(url, ' target="_blank" rel="noreferrer noopener nofollow" >\n      <img\n        class="fund-image"\n        src=').concat(fundImage, "\n        alt=").concat(title, '\n        loading="lazy"\n      />\n    </a>\n  </li>\n  ');
    });
}
$0d5360f8679c38dc$var$supportUkraineList.insertAdjacentHTML("beforeend", $0d5360f8679c38dc$var$createFundMarkup((0, $aqSZJ.fundList)).join(""));
// ---------------Swiper with buttons-------------------
var $0d5360f8679c38dc$var$fundBtnDown = document.querySelector(".fund-scroll-down");
var $0d5360f8679c38dc$var$fundBtnUp = document.querySelector(".fund-scroll-up");
$0d5360f8679c38dc$var$fundBtnUp.classList.add("hidden");
var $0d5360f8679c38dc$var$swiper = new (0, $aPlzd.S)(".my-swiper", {
    direction: "vertical",
    slidesPerView: "auto",
    navigation: {
        nextEl: ".swiper-button-down",
        prevEl: ".swiper-button-up"
    },
    plugins: {
        scrollContainer: true
    }
});
$0d5360f8679c38dc$var$fundBtnDown.addEventListener("click", function() {
    $0d5360f8679c38dc$var$swiper.slideNext();
});
$0d5360f8679c38dc$var$fundBtnUp.addEventListener("click", function() {
    $0d5360f8679c38dc$var$swiper.slidePrev();
});
var $0d5360f8679c38dc$var$hideDownObserver = new IntersectionObserver(function(entries) {
    if (entries[0].intersectionRatio <= 0) return;
    $0d5360f8679c38dc$var$fundBtnUp.classList.remove("hidden");
    $0d5360f8679c38dc$var$fundBtnDown.classList.add("hidden");
});
var $0d5360f8679c38dc$var$hideUpObserver = new IntersectionObserver(function(entries) {
    if (entries[0].intersectionRatio <= 0) return;
    $0d5360f8679c38dc$var$fundBtnUp.classList.add("hidden");
    $0d5360f8679c38dc$var$fundBtnDown.classList.remove("hidden");
});
$0d5360f8679c38dc$var$hideDownObserver.observe($0d5360f8679c38dc$var$supportUkraineList.lastElementChild);
$0d5360f8679c38dc$var$hideUpObserver.observe($0d5360f8679c38dc$var$supportUkraineList.firstElementChild);

});
parcelRequire.register("1FCkY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("aPlzd")).S; });
/**
 * Swiper 10.0.3
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: July 3, 2023
 */ 
var $aPlzd = parcelRequire("aPlzd");

});
parcelRequire.register("aPlzd", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $029bc59d811a92d7$export$25ce5a424b770e84; });

var $juqrk = parcelRequire("juqrk");

var $bNI6E = parcelRequire("bNI6E");

var $ect5N = parcelRequire("ect5N");

var $fGQt0 = parcelRequire("fGQt0");

var $aYXpI = parcelRequire("aYXpI");

var $keBYm = parcelRequire("keBYm");

var $6mOJw = parcelRequire("6mOJw");
var $029bc59d811a92d7$var$support;
function $029bc59d811a92d7$var$calcSupport() {
    var window1 = (0, $keBYm.a)();
    var document1 = (0, $keBYm.g)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $029bc59d811a92d7$var$getSupport() {
    if (!$029bc59d811a92d7$var$support) $029bc59d811a92d7$var$support = $029bc59d811a92d7$var$calcSupport();
    return $029bc59d811a92d7$var$support;
}
var $029bc59d811a92d7$var$deviceCached;
function $029bc59d811a92d7$var$calcDevice(_temp) {
    var userAgent = (_temp === void 0 ? {} : _temp).userAgent;
    var support = $029bc59d811a92d7$var$getSupport();
    var window1 = (0, $keBYm.a)();
    var platform = window1.navigator.platform;
    var ua = userAgent || window1.navigator.userAgent;
    var device = {
        ios: false,
        android: false
    };
    var screenWidth = window1.screen.width;
    var screenHeight = window1.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === "Win32";
    var macos = platform === "MacIntel";
    // iPadOs 13 fix
    var iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf("".concat(screenWidth, "x").concat(screenHeight)) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $029bc59d811a92d7$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$029bc59d811a92d7$var$deviceCached) $029bc59d811a92d7$var$deviceCached = $029bc59d811a92d7$var$calcDevice(overrides);
    return $029bc59d811a92d7$var$deviceCached;
}
var $029bc59d811a92d7$var$browser;
function $029bc59d811a92d7$var$calcBrowser() {
    var window1 = (0, $keBYm.a)();
    var needPerspectiveFix = false;
    function isSafari() {
        var ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        var ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            var _ua_split__split__split_map = (0, $fGQt0._)(ua.split("Version/")[1].split(" ")[0].split(".").map(function(num) {
                return Number(num);
            }), 2), major = _ua_split__split__split_map[0], minor = _ua_split__split__split_map[1];
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    return {
        isSafari: needPerspectiveFix || isSafari(),
        needPerspectiveFix: needPerspectiveFix,
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent)
    };
}
function $029bc59d811a92d7$var$getBrowser() {
    if (!$029bc59d811a92d7$var$browser) $029bc59d811a92d7$var$browser = $029bc59d811a92d7$var$calcBrowser();
    return $029bc59d811a92d7$var$browser;
}
function $029bc59d811a92d7$var$Resize(_ref) {
    var swiper = _ref.swiper, on = _ref.on, emit = _ref.emit;
    var window1 = (0, $keBYm.a)();
    var observer = null;
    var animationFrame = null;
    var resizeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    var createObserver = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver(function(entries) {
            animationFrame = window1.requestAnimationFrame(function() {
                var width = swiper.width, height = swiper.height;
                var newWidth = width;
                var newHeight = height;
                entries.forEach(function(_ref2) {
                    var contentBoxSize = _ref2.contentBoxSize, contentRect = _ref2.contentRect, target = _ref2.target;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    var removeObserver = function() {
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    var orientationChangeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", function() {
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", function() {
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function $029bc59d811a92d7$var$Observer(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var observers = [];
    var window1 = (0, $keBYm.a)();
    var attach = function attach(target, options) {
        if (options === void 0) options = {};
        var ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    var init = function() {
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = (0, $6mOJw.a)(swiper.el);
            for(var i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.el, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    var destroy = function() {
        observers.forEach(function(observer) {
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var $029bc59d811a92d7$var$eventsEmitter = {
    on: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        var method = priority ? "unshift" : "push";
        events.split(" ").forEach(function(event) {
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny: function(handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        var method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny: function(handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off: function(events, handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach(function(event) {
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler, index) {
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit: function() {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach(function(event) {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach(function(eventHandler) {
                eventHandler.apply(context, [
                    event
                ].concat((0, $aYXpI._)(data)));
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler) {
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $029bc59d811a92d7$var$updateSize() {
    var swiper = this;
    var width;
    var height;
    var el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $6mOJw.l)(el, "padding-left") || 0, 10) - parseInt((0, $6mOJw.l)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $6mOJw.l)(el, "padding-top") || 0, 10) - parseInt((0, $6mOJw.l)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $029bc59d811a92d7$var$updateSlides() {
    var swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    var params = swiper.params;
    var wrapperEl = swiper.wrapperEl, slidesEl = swiper.slidesEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = (0, $6mOJw.e)(slidesEl, ".".concat(swiper.params.slideClass, ", swiper-slide"));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach(function(slideEl) {
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $6mOJw.s)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $6mOJw.s)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
    // Calc slides
    var slideSize;
    var shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter(function(key) {
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = void 0;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slides[i] && (0, $6mOJw.l)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = "";
            var slideStyles = getComputedStyle(slide);
            var currentTransform = slide.style.transform;
            var currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $6mOJw.f)(slide, "width", true) : (0, $6mOJw.f)(slide, "height", true);
            else {
                // eslint-disable-next-line
                var width = getDirectionPropertyValue(slideStyles, "width");
                var paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                var paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                var marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                var marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                var boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    var clientWidth = slide.clientWidth, offsetWidth = slide.offsetWidth;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = "".concat(slideSize, "px");
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = "".concat(swiper.virtualSize + spaceBetween, "px");
    if (params.setWrapperSize) wrapperEl.style[getDirectionLabel("width")] = "".concat(swiper.virtualSize + spaceBetween, "px");
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        var newSlidesGrid = [];
        for(var i1 = 0; i1 < snapGrid.length; i1 += 1){
            var slidesGridItem = snapGrid[i1];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i1] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        var size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            var groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            var groupSize = size * params.slidesPerGroup;
            for(var i2 = 0; i2 < groups; i2 += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(var i3 = 0; i3 < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i3 += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        var key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter(function(_, slideIndex) {
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach(function(slideEl) {
            slideEl.style[key] = "".concat(spaceBetween, "px");
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        var maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map(function(snap) {
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var allSlidesSize1 = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize1 += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize1 -= spaceBetween;
        if (allSlidesSize1 < swiperSize) {
            var allSlidesOffset = (swiperSize - allSlidesSize1) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $6mOJw.s)(wrapperEl, "--swiper-centered-offset-before", "".concat(-snapGrid[0], "px"));
        (0, $6mOJw.s)(wrapperEl, "--swiper-centered-offset-after", "".concat(swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2, "px"));
        var addToSnapGrid = -swiper.snapGrid[0];
        var addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map(function(v) {
            return v + addToSnapGrid;
        });
        swiper.slidesGrid = swiper.slidesGrid.map(function(v) {
            return v + addToSlidesGrid;
        });
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        var backFaceHiddenClass = "".concat(params.containerModifierClass, "backface-hidden");
        var hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $029bc59d811a92d7$var$updateAutoHeight(speed) {
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var newHeight = 0;
    var i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    var getSlideByIndex = function(index) {
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach(function(slide) {
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = "".concat(newHeight, "px");
}
function $029bc59d811a92d7$var$updateSlidesOffset() {
    var swiper = this;
    var slides = swiper.slides;
    // eslint-disable-next-line
    var minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
function $029bc59d811a92d7$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.forEach(function(slideEl) {
        slideEl.classList.remove(params.slideVisibleClass);
    });
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    var spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        var slideBefore = -(offsetCenter - slideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides[i].classList.add(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $029bc59d811a92d7$var$updateProgress(translate) {
    var swiper = this;
    if (typeof translate === "undefined") {
        var multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd, progressLoop = swiper.progressLoop;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        var isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        var isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        var firstSlideIndex = swiper.getSlideIndexByData(0);
        var lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        var firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        var lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        var translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        var translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
function $029bc59d811a92d7$var$updateSlidesClasses() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, slidesEl = swiper.slidesEl, activeIndex = swiper.activeIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var getFilteredSlide = function(selector) {
        return (0, $6mOJw.e)(slidesEl, ".".concat(params.slideClass).concat(selector, ", swiper-slide").concat(selector))[0];
    };
    slides.forEach(function(slideEl) {
        slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
    });
    var activeSlide;
    if (isVirtual) {
        if (params.loop) {
            var slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide('[data-swiper-slide-index="'.concat(slideIndex, '"]'));
        } else activeSlide = getFilteredSlide('[data-swiper-slide-index="'.concat(activeIndex, '"]'));
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        // Active classes
        activeSlide.classList.add(params.slideActiveClass);
        // Next Slide
        var nextSlide = (0, $6mOJw.m)(activeSlide, ".".concat(params.slideClass, ", swiper-slide"))[0];
        if (params.loop && !nextSlide) nextSlide = slides[0];
        if (nextSlide) nextSlide.classList.add(params.slideNextClass);
        // Prev Slide
        var prevSlide = (0, $6mOJw.o)(activeSlide, ".".concat(params.slideClass, ", swiper-slide"))[0];
        params.loop;
        if (prevSlide) prevSlide.classList.add(params.slidePrevClass);
    }
    swiper.emitSlidesClasses();
}
var $029bc59d811a92d7$var$processLazyPreloader = function(swiper, imageEl) {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    var slideSelector = function() {
        return swiper.isElement ? "swiper-slide" : ".".concat(swiper.params.slideClass);
    };
    var slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        var lazyEl = slideEl.querySelector(".".concat(swiper.params.lazyPreloaderClass));
        if (lazyEl) lazyEl.remove();
    }
};
var $029bc59d811a92d7$var$unlazy = function(swiper, index) {
    if (!swiper.slides[index]) return;
    var imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
var $029bc59d811a92d7$var$preload = function(swiper) {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    var amount = swiper.params.lazyPreloadPrevNext;
    var len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    var slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    var activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        var _preloadColumns;
        var activeColumn = activeIndex;
        var preloadColumns = [
            activeColumn - amount
        ];
        (_preloadColumns = preloadColumns).push.apply(_preloadColumns, (0, $aYXpI._)(Array.from({
            length: amount
        }).map(function(_, i) {
            return activeColumn + slidesPerView + i;
        })));
        swiper.slides.forEach(function(slideEl, i) {
            if (preloadColumns.includes(slideEl.column)) $029bc59d811a92d7$var$unlazy(swiper, i);
        });
        return;
    }
    var slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(var i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        var realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $029bc59d811a92d7$var$unlazy(swiper, realIndex);
    }
    else {
        for(var i1 = Math.max(activeIndex - amount, 0); i1 <= Math.min(slideIndexLastInView + amount, len - 1); i1 += 1)if (i1 !== activeIndex && (i1 > slideIndexLastInView || i1 < activeIndex)) $029bc59d811a92d7$var$unlazy(swiper, i1);
    }
};
function $029bc59d811a92d7$var$getActiveIndexByTranslate(swiper) {
    var slidesGrid = swiper.slidesGrid, params = swiper.params;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var activeIndex;
    for(var i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $029bc59d811a92d7$var$updateActiveIndex(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    var getVirtualRealIndex = function(aIndex) {
        var realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $029bc59d811a92d7$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    // Get real index
    var realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (swiper.slides[activeIndex]) realIndex = parseInt(swiper.slides[activeIndex].getAttribute("data-swiper-slide-index") || activeIndex, 10);
    else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $029bc59d811a92d7$var$preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}
function $029bc59d811a92d7$var$updateClickedSlide(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = e.closest(".".concat(params.slideClass, ", swiper-slide"));
    var slideFound = false;
    var slideIndex;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $029bc59d811a92d7$var$update = {
    updateSize: $029bc59d811a92d7$var$updateSize,
    updateSlides: $029bc59d811a92d7$var$updateSlides,
    updateAutoHeight: $029bc59d811a92d7$var$updateAutoHeight,
    updateSlidesOffset: $029bc59d811a92d7$var$updateSlidesOffset,
    updateSlidesProgress: $029bc59d811a92d7$var$updateSlidesProgress,
    updateProgress: $029bc59d811a92d7$var$updateProgress,
    updateSlidesClasses: $029bc59d811a92d7$var$updateSlidesClasses,
    updateActiveIndex: $029bc59d811a92d7$var$updateActiveIndex,
    updateClickedSlide: $029bc59d811a92d7$var$updateClickedSlide
};
function $029bc59d811a92d7$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, wrapperEl = swiper.wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    var currentTranslate = (0, $6mOJw.h)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $029bc59d811a92d7$var$setTranslate(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = "translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)");
    }
    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function $029bc59d811a92d7$var$minTranslate() {
    return -this.snapGrid[0];
}
function $029bc59d811a92d7$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $029bc59d811a92d7$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var _$minTranslate = swiper.minTranslate();
    var _$maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > _$minTranslate) newTranslate = _$minTranslate;
    else if (translateBounds && translate < _$maxTranslate) newTranslate = _$maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $6mOJw.p)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, $ect5N._)(_obj, isH ? "left" : "top", -newTranslate), (0, $ect5N._)(_obj, "behavior", "smooth"), _obj));
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $029bc59d811a92d7$var$translate = {
    getTranslate: $029bc59d811a92d7$var$getSwiperTranslate,
    setTranslate: $029bc59d811a92d7$var$setTranslate,
    minTranslate: $029bc59d811a92d7$var$minTranslate,
    maxTranslate: $029bc59d811a92d7$var$maxTranslate,
    translateTo: $029bc59d811a92d7$var$translateTo
};
function $029bc59d811a92d7$var$setTransition(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) swiper.wrapperEl.style.transitionDuration = "".concat(duration, "ms");
    swiper.emit("setTransition", duration, byController);
}
function $029bc59d811a92d7$var$transitionEmit(_ref) {
    var swiper = _ref.swiper, runCallbacks = _ref.runCallbacks, direction = _ref.direction, step = _ref.step;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex;
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit("transition".concat(step));
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit("slideResetTransition".concat(step));
            return;
        }
        swiper.emit("slideChangeTransition".concat(step));
        if (dir === "next") swiper.emit("slideNextTransition".concat(step));
        else swiper.emit("slidePrevTransition".concat(step));
    }
}
function $029bc59d811a92d7$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $029bc59d811a92d7$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}
function $029bc59d811a92d7$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $029bc59d811a92d7$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}
var $029bc59d811a92d7$var$transition = {
    setTransition: $029bc59d811a92d7$var$setTransition,
    transitionStart: $029bc59d811a92d7$var$transitionStart,
    transitionEnd: $029bc59d811a92d7$var$transitionEnd
};
function $029bc59d811a92d7$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl, enabled = swiper.enabled;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    var translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(var i = 0; i < slidesGrid.length; i += 1){
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGrid = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    var direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = rtl ? translate : -translate;
        if (speed === 0) {
            var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(function() {
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(function() {
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $6mOJw.p)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, $ect5N._)(_obj, isH ? "left" : "top", t), (0, $ect5N._)(_obj, "behavior", "smooth"), _obj));
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $029bc59d811a92d7$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        var indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else newIndex = swiper.getSlideIndexByData(newIndex);
    }
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideNext(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var enabled = swiper.enabled, params = swiper.params, animating = swiper.animating;
    if (!enabled) return swiper;
    var perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slidePrev(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled, animating = swiper.animating;
    if (!enabled) return swiper;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        var prevSnapIndex;
        snapGrid.forEach(function(snap, snapIndex) {
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    var prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        var lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideReset(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    var swiper = this;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var currentSnap1 = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap1 - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $029bc59d811a92d7$var$slideToClickedSlide() {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    var slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    var slideSelector = swiper.isElement ? "swiper-slide" : ".".concat(params.slideClass);
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $6mOJw.e)(slidesEl, "".concat(slideSelector, '[data-swiper-slide-index="').concat(realIndex, '"]'))[0]);
                (0, $6mOJw.n)(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $6mOJw.e)(slidesEl, "".concat(slideSelector, '[data-swiper-slide-index="').concat(realIndex, '"]'))[0]);
            (0, $6mOJw.n)(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $029bc59d811a92d7$var$slide = {
    slideTo: $029bc59d811a92d7$var$slideTo,
    slideToLoop: $029bc59d811a92d7$var$slideToLoop,
    slideNext: $029bc59d811a92d7$var$slideNext,
    slidePrev: $029bc59d811a92d7$var$slidePrev,
    slideReset: $029bc59d811a92d7$var$slideReset,
    slideToClosest: $029bc59d811a92d7$var$slideToClosest,
    slideToClickedSlide: $029bc59d811a92d7$var$slideToClickedSlide
};
function $029bc59d811a92d7$var$loopCreate(slideRealIndex) {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    var slides = (0, $6mOJw.e)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
    slides.forEach(function(el, index) {
        el.setAttribute("data-swiper-slide-index", index);
    });
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}
function $029bc59d811a92d7$var$loopFix(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, slideRealIndex = _ref.slideRealIndex, _ref_slideTo = _ref.slideTo, _$slideTo = _ref_slideTo === void 0 ? true : _ref_slideTo, direction = _ref.direction, _$setTranslate = _ref.setTranslate, activeSlideIndex = _ref.activeSlideIndex, byController = _ref.byController, byMousewheel = _ref.byMousewheel;
    var swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    var slides = swiper.slides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, slidesEl = swiper.slidesEl, params = swiper.params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (_$slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    var slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10));
    var loopedSlides = params.loopedSlides || slidesPerView;
    if (loopedSlides % params.slidesPerGroup !== 0) loopedSlides += params.slidesPerGroup - loopedSlides % params.slidesPerGroup;
    swiper.loopedSlides = loopedSlides;
    var prependSlidesIndexes = [];
    var appendSlidesIndexes = [];
    var activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(swiper.slides.filter(function(el) {
        return el.classList.contains(params.slideActiveClass);
    })[0]);
    else activeIndex = activeSlideIndex;
    var isNext = direction === "next" || !direction;
    var isPrev = direction === "prev" || !direction;
    var slidesPrepended = 0;
    var slidesAppended = 0;
    // prepend last slides before start
    if (activeSlideIndex < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeSlideIndex, params.slidesPerGroup);
        for(var i = 0; i < loopedSlides - activeSlideIndex; i += 1){
            var index = i - Math.floor(i / slides.length) * slides.length;
            prependSlidesIndexes.push(slides.length - index - 1);
        }
    } else if (activeSlideIndex /* + slidesPerView */  > swiper.slides.length - loopedSlides * 2) {
        slidesAppended = Math.max(activeSlideIndex - (swiper.slides.length - loopedSlides * 2), params.slidesPerGroup);
        for(var i1 = 0; i1 < slidesAppended; i1 += 1){
            var index1 = i1 - Math.floor(i1 / slides.length) * slides.length;
            appendSlidesIndexes.push(index1);
        }
    }
    if (isPrev) prependSlidesIndexes.forEach(function(index) {
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach(function(index) {
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (_$slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                var currentSlideTranslate = swiper.slidesGrid[activeIndex];
                var newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                var diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
                    if (_$setTranslate) swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
                }
            } else if (_$setTranslate) swiper.slideToLoop(slideRealIndex, 0, false, true);
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                var currentSlideTranslate1 = swiper.slidesGrid[activeIndex];
                var newSlideTranslate1 = swiper.slidesGrid[activeIndex - slidesAppended];
                var diff1 = newSlideTranslate1 - currentSlideTranslate1;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff1);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (_$setTranslate) swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff1;
                }
            } else swiper.slideToLoop(slideRealIndex, 0, false, true);
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        var loopParams = {
            slideRealIndex: slideRealIndex,
            slideTo: false,
            direction: direction,
            setTranslate: _$setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach(function(c) {
            if (!c.destroyed && c.params.loop) c.loopFix(loopParams);
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix(loopParams);
    }
    swiper.emit("loopFix");
}
function $029bc59d811a92d7$var$loopDestroy() {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    var newSlidesOrder = [];
    swiper.slides.forEach(function(slideEl) {
        var index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach(function(slideEl) {
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach(function(slideEl) {
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $029bc59d811a92d7$var$loop = {
    loopCreate: $029bc59d811a92d7$var$loopCreate,
    loopFix: $029bc59d811a92d7$var$loopFix,
    loopDestroy: $029bc59d811a92d7$var$loopDestroy
};
function $029bc59d811a92d7$var$setGrabCursor(moving) {
    var swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}
function $029bc59d811a92d7$var$unsetGrabCursor() {
    var swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}
var $029bc59d811a92d7$var$grabCursor = {
    setGrabCursor: $029bc59d811a92d7$var$setGrabCursor,
    unsetGrabCursor: $029bc59d811a92d7$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $029bc59d811a92d7$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $keBYm.g)() || el === (0, $keBYm.a)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        var found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $029bc59d811a92d7$var$onTouchStart(event) {
    var swiper = this;
    var document1 = (0, $keBYm.g)();
    var window1 = (0, $keBYm.a)();
    var data = swiper.touchEventsData;
    data.evCache.push(event);
    var params = swiper.params, touches = swiper.touches, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!swiper.wrapperEl.contains(targetEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    var eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass);
    var isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $029bc59d811a92d7$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $6mOJw.d)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    var preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl) document1.activeElement.blur();
    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function $029bc59d811a92d7$var$onTouchMove(event) {
    var document1 = (0, $keBYm.g)();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    var pointerIndex = data.evCache.findIndex(function(cachedEv) {
        return cachedEv.pointerId === e.pointerId;
    });
    if (pointerIndex >= 0) data.evCache[pointerIndex] = e;
    var targetTouch = data.evCache.length > 1 ? data.evCache[0] : e;
    var pageX = targetTouch.pageX;
    var pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                prevX: swiper.touches.currentX,
                prevY: swiper.touches.currentY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $6mOJw.d)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || swiper.zoom && swiper.params.zoom && swiper.params.zoom.enabled && data.evCache.length > 1) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    var diff = swiper.isHorizontal() ? diffX : diffY;
    var touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    var prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    var isLoop = swiper.params.loop && !params.cssMode;
    if (!data.isMoved) {
        if (isLoop) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            var evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    var loopFixed;
    if (data.isMoved && prevTouchesDirection !== swiper.touchesDirection && isLoop && Math.abs(diff) >= 1) {
        // need another loop fix
        swiper.loopFix({
            direction: swiper.swipeDirection,
            setTranslate: true
        });
        loopFixed = true;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && !loopFixed && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.size / 2 : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
        }
    } else if (diff < 0) {
        if (isLoop && !loopFixed && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.size / 2 : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $029bc59d811a92d7$var$onTouchEnd(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var pointerIndex = data.evCache.findIndex(function(cachedEv) {
        return cachedEv.pointerId === event.pointerId;
    });
    if (pointerIndex >= 0) data.evCache.splice(pointerIndex, 1);
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave"
    ].includes(event.type)) {
        var proceed = event.type === "pointercancel" && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, slidesGrid = swiper.slidesGrid, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    var touchEndTime = (0, $6mOJw.d)();
    var timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        var pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $6mOJw.d)();
    (0, $6mOJw.n)(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    var rewindFirstIndex = null;
    var rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment1 = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment1);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment1);
        else swiper.slideTo(stopIndex);
    }
}
function $029bc59d811a92d7$var$onResize() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    var isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(function() {
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $029bc59d811a92d7$var$onClick(e) {
    var swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $029bc59d811a92d7$var$onScroll() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function $029bc59d811a92d7$var$onLoad(e) {
    var swiper = this;
    $029bc59d811a92d7$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
var $029bc59d811a92d7$var$dummyEventAttached = false;
function $029bc59d811a92d7$var$dummyEventListener() {}
var $029bc59d811a92d7$var$events = function(swiper, method) {
    var document1 = (0, $keBYm.g)();
    var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device;
    var capture = !!params.nested;
    var domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    var swiperMethod = method;
    // Touch Events
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $029bc59d811a92d7$var$onResize, true);
    else swiper[swiperMethod]("observerUpdate", $029bc59d811a92d7$var$onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $029bc59d811a92d7$var$attachEvents() {
    var swiper = this;
    var document1 = (0, $keBYm.g)();
    var params = swiper.params;
    swiper.onTouchStart = $029bc59d811a92d7$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $029bc59d811a92d7$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $029bc59d811a92d7$var$onTouchEnd.bind(swiper);
    if (params.cssMode) swiper.onScroll = $029bc59d811a92d7$var$onScroll.bind(swiper);
    swiper.onClick = $029bc59d811a92d7$var$onClick.bind(swiper);
    swiper.onLoad = $029bc59d811a92d7$var$onLoad.bind(swiper);
    if (!$029bc59d811a92d7$var$dummyEventAttached) {
        document1.addEventListener("touchstart", $029bc59d811a92d7$var$dummyEventListener);
        $029bc59d811a92d7$var$dummyEventAttached = true;
    }
    $029bc59d811a92d7$var$events(swiper, "on");
}
function $029bc59d811a92d7$var$detachEvents() {
    var swiper = this;
    $029bc59d811a92d7$var$events(swiper, "off");
}
var $029bc59d811a92d7$var$events$1 = {
    attachEvents: $029bc59d811a92d7$var$attachEvents,
    detachEvents: $029bc59d811a92d7$var$detachEvents
};
var $029bc59d811a92d7$var$isGridEnabled = function(swiper, params) {
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $029bc59d811a92d7$var$setBreakpoint() {
    var swiper = this;
    var realIndex = swiper.realIndex, initialized = swiper.initialized, params = swiper.params, el = swiper.el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = $029bc59d811a92d7$var$isGridEnabled(swiper, params);
    var isMultiRow = $029bc59d811a92d7$var$isGridEnabled(swiper, breakpointParams);
    var wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove("".concat(params.containerModifierClass, "grid"), "".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add("".concat(params.containerModifierClass, "grid"));
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add("".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    }
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach(function(prop) {
        if (typeof breakpointParams[prop] === "undefined") return;
        var wasModuleEnabled = params[prop] && params[prop].enabled;
        var isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $6mOJw.q)(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate(realIndex);
        swiper.updateSlides();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function $029bc59d811a92d7$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    var breakpoint = false;
    var window1 = (0, $keBYm.a)();
    var currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === "string" && point.indexOf("@") === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _points_i = points[i], point = _points_i.point, value = _points_i.value;
        if (base === "window") {
            if (window1.matchMedia("(min-width: ".concat(value, "px)")).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var $029bc59d811a92d7$var$breakpoints = {
    setBreakpoint: $029bc59d811a92d7$var$setBreakpoint,
    getBreakpoint: $029bc59d811a92d7$var$getBreakpoint
};
function $029bc59d811a92d7$var$prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function(item) {
        if (typeof item === "object") Object.keys(item).forEach(function(classNames) {
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $029bc59d811a92d7$var$addClasses() {
    var _classNames, _el_classList;
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, el = swiper.el, device = swiper.device;
    // prettier-ignore
    var suffixes = $029bc59d811a92d7$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    (_classNames = classNames).push.apply(_classNames, (0, $aYXpI._)(suffixes));
    (_el_classList = el.classList).add.apply(_el_classList, (0, $aYXpI._)(classNames));
    swiper.emitContainerClasses();
}
function $029bc59d811a92d7$var$removeClasses() {
    var _el_classList;
    var swiper = this;
    var el = swiper.el, classNames = swiper.classNames;
    (_el_classList = el.classList).remove.apply(_el_classList, (0, $aYXpI._)(classNames));
    swiper.emitContainerClasses();
}
var $029bc59d811a92d7$var$classes = {
    addClasses: $029bc59d811a92d7$var$addClasses,
    removeClasses: $029bc59d811a92d7$var$removeClasses
};
function $029bc59d811a92d7$var$checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked, params = swiper.params;
    var slidesOffsetBefore = params.slidesOffsetBefore;
    if (slidesOffsetBefore) {
        var lastSlideIndex = swiper.slides.length - 1;
        var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $029bc59d811a92d7$var$checkOverflow$1 = {
    checkOverflow: $029bc59d811a92d7$var$checkOverflow
};
var $029bc59d811a92d7$export$4368d992c4eafac0 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopedSlides: null,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $029bc59d811a92d7$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        var moduleParamName = Object.keys(obj)[0];
        var moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $6mOJw.q)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $6mOJw.q)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $6mOJw.q)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ var $029bc59d811a92d7$var$prototypes = {
    eventsEmitter: $029bc59d811a92d7$var$eventsEmitter,
    update: $029bc59d811a92d7$var$update,
    translate: $029bc59d811a92d7$var$translate,
    transition: $029bc59d811a92d7$var$transition,
    slide: $029bc59d811a92d7$var$slide,
    loop: $029bc59d811a92d7$var$loop,
    grabCursor: $029bc59d811a92d7$var$grabCursor,
    events: $029bc59d811a92d7$var$events$1,
    breakpoints: $029bc59d811a92d7$var$breakpoints,
    checkOverflow: $029bc59d811a92d7$var$checkOverflow$1,
    classes: $029bc59d811a92d7$var$classes
};
var $029bc59d811a92d7$var$extendedDefaults = {};
var $029bc59d811a92d7$export$25ce5a424b770e84 = /*#__PURE__*/ function() {
    "use strict";
    function Swiper() {
        var _swiper_modules;
        (0, $juqrk._)(this, Swiper);
        var el;
        var params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var ref;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else ref = (0, $fGQt0._)(args, 2), el = ref[0], params = ref[1], ref;
        if (!params) params = {};
        params = (0, $6mOJw.q)({}, params);
        if (el && !params.el) params.el = el;
        var document1 = (0, $keBYm.g)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            var swipers = [];
            document1.querySelectorAll(params.el).forEach(function(containerEl) {
                var newParams = (0, $6mOJw.q)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        var swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $029bc59d811a92d7$var$getSupport();
        swiper.device = $029bc59d811a92d7$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $029bc59d811a92d7$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = (0, $aYXpI._)(swiper.__modules__);
        if (params.modules && Array.isArray(params.modules)) (_swiper_modules = swiper.modules).push.apply(_swiper_modules, (0, $aYXpI._)(params.modules));
        var allModulesParams = {};
        swiper.modules.forEach(function(mod) {
            mod({
                params: params,
                swiper: swiper,
                extendParams: $029bc59d811a92d7$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        var swiperParams = (0, $6mOJw.q)({}, $029bc59d811a92d7$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $6mOJw.q)({}, swiperParams, $029bc59d811a92d7$var$extendedDefaults, params);
        swiper.originalParams = (0, $6mOJw.q)({}, swiper.params);
        swiper.passedParams = (0, $6mOJw.q)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach(function(eventName) {
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function() {
                return swiper.params.direction === "horizontal";
            },
            isVertical: function() {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment: function() {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                evCache: []
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    (0, $bNI6E._)(Swiper, [
        {
            key: "getSlideIndex",
            value: function getSlideIndex(slideEl) {
                var _this = this, slidesEl = _this.slidesEl, params = _this.params;
                var slides = (0, $6mOJw.e)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
                var firstSlideIndex = (0, $6mOJw.g)(slides[0]);
                return (0, $6mOJw.g)(slideEl) - firstSlideIndex;
            }
        },
        {
            key: "getSlideIndexByData",
            value: function getSlideIndexByData(index) {
                return this.getSlideIndex(this.slides.filter(function(slideEl) {
                    return slideEl.getAttribute("data-swiper-slide-index") * 1 === index;
                })[0]);
            }
        },
        {
            key: "recalcSlides",
            value: function recalcSlides() {
                var swiper = this;
                var slidesEl = swiper.slidesEl, params = swiper.params;
                swiper.slides = (0, $6mOJw.e)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
            }
        },
        {
            key: "enable",
            value: function enable() {
                var swiper = this;
                if (swiper.enabled) return;
                swiper.enabled = true;
                if (swiper.params.grabCursor) swiper.setGrabCursor();
                swiper.emit("enable");
            }
        },
        {
            key: "disable",
            value: function disable() {
                var swiper = this;
                if (!swiper.enabled) return;
                swiper.enabled = false;
                if (swiper.params.grabCursor) swiper.unsetGrabCursor();
                swiper.emit("disable");
            }
        },
        {
            key: "setProgress",
            value: function setProgress(progress, speed) {
                var swiper = this;
                progress = Math.min(Math.max(progress, 0), 1);
                var min = swiper.minTranslate();
                var max = swiper.maxTranslate();
                var current = (max - min) * progress + min;
                swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
            }
        },
        {
            key: "emitContainerClasses",
            value: function emitContainerClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var cls = swiper.el.className.split(" ").filter(function(className) {
                    return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
                });
                swiper.emit("_containerClasses", cls.join(" "));
            }
        },
        {
            key: "getSlideClasses",
            value: function getSlideClasses(slideEl) {
                var swiper = this;
                if (swiper.destroyed) return "";
                return slideEl.className.split(" ").filter(function(className) {
                    return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
                }).join(" ");
            }
        },
        {
            key: "emitSlidesClasses",
            value: function emitSlidesClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var updates = [];
                swiper.slides.forEach(function(slideEl) {
                    var classNames = swiper.getSlideClasses(slideEl);
                    updates.push({
                        slideEl: slideEl,
                        classNames: classNames
                    });
                    swiper.emit("_slideClass", slideEl, classNames);
                });
                swiper.emit("_slideClasses", updates);
            }
        },
        {
            key: "slidesPerViewDynamic",
            value: function slidesPerViewDynamic(view, exact) {
                if (view === void 0) view = "current";
                if (exact === void 0) exact = false;
                var swiper = this;
                var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, slidesSizesGrid = swiper.slidesSizesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
                var spv = 1;
                if (params.centeredSlides) {
                    var slideSize = slides[activeIndex] ? slides[activeIndex].swiperSlideSize : 0;
                    var breakLoop;
                    for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                        slideSize += slides[i].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                    for(var i1 = activeIndex - 1; i1 >= 0; i1 -= 1)if (slides[i1] && !breakLoop) {
                        slideSize += slides[i1].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                } else {
                    // eslint-disable-next-line
                    if (view === "current") for(var i2 = activeIndex + 1; i2 < slides.length; i2 += 1){
                        var slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
                        if (slideInView) spv += 1;
                    }
                    else // previous
                    for(var i3 = activeIndex - 1; i3 >= 0; i3 -= 1){
                        var slideInView1 = slidesGrid[activeIndex] - slidesGrid[i3] < swiperSize;
                        if (slideInView1) spv += 1;
                    }
                }
                return spv;
            }
        },
        {
            key: "update",
            value: function update() {
                var swiper = this;
                if (!swiper || swiper.destroyed) return;
                var snapGrid = swiper.snapGrid, params = swiper.params;
                // Breakpoints
                if (params.breakpoints) swiper.setBreakpoint();
                (0, $aYXpI._)(swiper.el.querySelectorAll('[loading="lazy"]')).forEach(function(imageEl) {
                    if (imageEl.complete) $029bc59d811a92d7$var$processLazyPreloader(swiper, imageEl);
                });
                swiper.updateSize();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();
                function setTranslate() {
                    var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
                    var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
                    swiper.setTranslate(newTranslate);
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                }
                var translated;
                if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
                    setTranslate();
                    if (params.autoHeight) swiper.updateAutoHeight();
                } else {
                    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                        var slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                        translated = swiper.slideTo(slides.length - 1, 0, false, true);
                    } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
                    if (!translated) setTranslate();
                }
                if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
                swiper.emit("update");
            }
        },
        {
            key: "changeDirection",
            value: function changeDirection(newDirection, needUpdate) {
                if (needUpdate === void 0) needUpdate = true;
                var swiper = this;
                var currentDirection = swiper.params.direction;
                if (!newDirection) // eslint-disable-next-line
                newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
                if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
                swiper.el.classList.remove("".concat(swiper.params.containerModifierClass).concat(currentDirection));
                swiper.el.classList.add("".concat(swiper.params.containerModifierClass).concat(newDirection));
                swiper.emitContainerClasses();
                swiper.params.direction = newDirection;
                swiper.slides.forEach(function(slideEl) {
                    if (newDirection === "vertical") slideEl.style.width = "";
                    else slideEl.style.height = "";
                });
                swiper.emit("changeDirection");
                if (needUpdate) swiper.update();
                return swiper;
            }
        },
        {
            key: "changeLanguageDirection",
            value: function changeLanguageDirection(direction) {
                var swiper = this;
                if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
                swiper.rtl = direction === "rtl";
                swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
                if (swiper.rtl) {
                    swiper.el.classList.add("".concat(swiper.params.containerModifierClass, "rtl"));
                    swiper.el.dir = "rtl";
                } else {
                    swiper.el.classList.remove("".concat(swiper.params.containerModifierClass, "rtl"));
                    swiper.el.dir = "ltr";
                }
                swiper.update();
            }
        },
        {
            key: "mount",
            value: function mount(element) {
                var swiper = this;
                if (swiper.mounted) return true;
                // Find el
                var el = element || swiper.params.el;
                if (typeof el === "string") el = document.querySelector(el);
                if (!el) return false;
                el.swiper = swiper;
                if (el.parentNode && el.parentNode.host) swiper.isElement = true;
                var getWrapperSelector = function() {
                    return ".".concat((swiper.params.wrapperClass || "").trim().split(" ").join("."));
                };
                var getWrapper = function() {
                    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                        var res = el.shadowRoot.querySelector(getWrapperSelector());
                        // Children needs to return slot items
                        return res;
                    }
                    return (0, $6mOJw.e)(el, getWrapperSelector())[0];
                };
                // Find Wrapper
                var wrapperEl = getWrapper();
                if (!wrapperEl && swiper.params.createElements) {
                    wrapperEl = (0, $6mOJw.c)("div", swiper.params.wrapperClass);
                    el.append(wrapperEl);
                    (0, $6mOJw.e)(el, ".".concat(swiper.params.slideClass)).forEach(function(slideEl) {
                        wrapperEl.append(slideEl);
                    });
                }
                Object.assign(swiper, {
                    el: el,
                    wrapperEl: wrapperEl,
                    slidesEl: swiper.isElement ? el.parentNode.host : wrapperEl,
                    hostEl: swiper.isElement ? el.parentNode.host : el,
                    mounted: true,
                    // RTL
                    rtl: el.dir.toLowerCase() === "rtl" || (0, $6mOJw.l)(el, "direction") === "rtl",
                    rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $6mOJw.l)(el, "direction") === "rtl"),
                    wrongRTL: (0, $6mOJw.l)(wrapperEl, "display") === "-webkit-box"
                });
                return true;
            }
        },
        {
            key: "init",
            value: function init(el) {
                var swiper = this;
                if (swiper.initialized) return swiper;
                var mounted = swiper.mount(el);
                if (mounted === false) return swiper;
                swiper.emit("beforeInit");
                // Set breakpoint
                if (swiper.params.breakpoints) swiper.setBreakpoint();
                // Add Classes
                swiper.addClasses();
                // Update size
                swiper.updateSize();
                // Update slides
                swiper.updateSlides();
                if (swiper.params.watchOverflow) swiper.checkOverflow();
                // Set Grab Cursor
                if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
                // Slide To Initial Slide
                if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
                else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
                // Create loop
                if (swiper.params.loop) swiper.loopCreate();
                // Attach events
                swiper.attachEvents();
                (0, $aYXpI._)(swiper.el.querySelectorAll('[loading="lazy"]')).forEach(function(imageEl) {
                    if (imageEl.complete) $029bc59d811a92d7$var$processLazyPreloader(swiper, imageEl);
                    else imageEl.addEventListener("load", function(e) {
                        $029bc59d811a92d7$var$processLazyPreloader(swiper, e.target);
                    });
                });
                $029bc59d811a92d7$var$preload(swiper);
                // Init Flag
                swiper.initialized = true;
                $029bc59d811a92d7$var$preload(swiper);
                // Emit
                swiper.emit("init");
                swiper.emit("afterInit");
                return swiper;
            }
        },
        {
            key: "destroy",
            value: function destroy(deleteInstance, cleanStyles) {
                if (deleteInstance === void 0) deleteInstance = true;
                if (cleanStyles === void 0) cleanStyles = true;
                var swiper = this;
                var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides;
                if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
                swiper.emit("beforeDestroy");
                // Init Flag
                swiper.initialized = false;
                // Detach events
                swiper.detachEvents();
                // Destroy loop
                if (params.loop) swiper.loopDestroy();
                // Cleanup styles
                if (cleanStyles) {
                    swiper.removeClasses();
                    el.removeAttribute("style");
                    wrapperEl.removeAttribute("style");
                    if (slides && slides.length) slides.forEach(function(slideEl) {
                        slideEl.classList.remove(params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                        slideEl.removeAttribute("style");
                        slideEl.removeAttribute("data-swiper-slide-index");
                    });
                }
                swiper.emit("destroy");
                // Detach emitter events
                Object.keys(swiper.eventsListeners).forEach(function(eventName) {
                    swiper.off(eventName);
                });
                if (deleteInstance !== false) {
                    swiper.el.swiper = null;
                    (0, $6mOJw.r)(swiper);
                }
                swiper.destroyed = true;
                return null;
            }
        }
    ], [
        {
            key: "extendDefaults",
            value: function extendDefaults(newDefaults) {
                (0, $6mOJw.q)($029bc59d811a92d7$var$extendedDefaults, newDefaults);
            }
        },
        {
            key: "extendedDefaults",
            get: function get() {
                return $029bc59d811a92d7$var$extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return $029bc59d811a92d7$export$4368d992c4eafac0;
            }
        },
        {
            key: "installModule",
            value: function installModule(mod) {
                if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
                var modules = Swiper.prototype.__modules__;
                if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (Array.isArray(module)) {
                    module.forEach(function(m) {
                        return Swiper.installModule(m);
                    });
                    return Swiper;
                }
                Swiper.installModule(module);
                return Swiper;
            }
        }
    ]);
    return Swiper;
}();
Object.keys($029bc59d811a92d7$var$prototypes).forEach(function(prototypeGroup) {
    Object.keys($029bc59d811a92d7$var$prototypes[prototypeGroup]).forEach(function(protoMethod) {
        $029bc59d811a92d7$export$25ce5a424b770e84.prototype[protoMethod] = $029bc59d811a92d7$var$prototypes[prototypeGroup][protoMethod];
    });
});
$029bc59d811a92d7$export$25ce5a424b770e84.use([
    $029bc59d811a92d7$var$Resize,
    $029bc59d811a92d7$var$Observer
]);

});
parcelRequire.register("ect5N", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a568c0d5880c90ba$export$1e71eb4bef00f6b0; });
function $a568c0d5880c90ba$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRequire.register("keBYm", function(module, exports) {

$parcel$export(module.exports, "g", function () { return $6b317c2177284918$export$39b482c5e57630a8; });
$parcel$export(module.exports, "a", function () { return $6b317c2177284918$export$407448d2b89b1813; });
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $6b317c2177284918$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $6b317c2177284918$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach(function(key) {
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($6b317c2177284918$var$isObject(src[key]) && $6b317c2177284918$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $6b317c2177284918$var$extend(target[key], src[key]);
    });
}
var $6b317c2177284918$var$ssrDocument = {
    body: {},
    addEventListener: function() {},
    removeEventListener: function() {},
    activeElement: {
        blur: function() {},
        nodeName: ""
    },
    querySelector: function() {
        return null;
    },
    querySelectorAll: function() {
        return [];
    },
    getElementById: function() {
        return null;
    },
    createEvent: function() {
        return {
            initEvent: function() {}
        };
    },
    createElement: function() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function() {},
            getElementsByTagName: function() {
                return [];
            }
        };
    },
    createElementNS: function() {
        return {};
    },
    importNode: function() {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $6b317c2177284918$export$39b482c5e57630a8() {
    var doc = typeof document !== "undefined" ? document : {};
    $6b317c2177284918$var$extend(doc, $6b317c2177284918$var$ssrDocument);
    return doc;
}
var $6b317c2177284918$var$ssrWindow = {
    document: $6b317c2177284918$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState: function() {},
        pushState: function() {},
        go: function() {},
        back: function() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function() {},
    removeEventListener: function() {},
    getComputedStyle: function() {
        return {
            getPropertyValue: function() {
                return "";
            }
        };
    },
    Image: function() {},
    Date: function() {},
    screen: {},
    setTimeout: function() {},
    clearTimeout: function() {},
    matchMedia: function() {
        return {};
    },
    requestAnimationFrame: function(callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function(id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $6b317c2177284918$export$407448d2b89b1813() {
    var win = typeof window !== "undefined" ? window : {};
    $6b317c2177284918$var$extend(win, $6b317c2177284918$var$ssrWindow);
    return win;
}

});

parcelRequire.register("6mOJw", function(module, exports) {

$parcel$export(module.exports, "r", function () { return $36f917fbf2efdd6b$export$43caf9889c228507; });
$parcel$export(module.exports, "n", function () { return $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "d", function () { return $36f917fbf2efdd6b$export$4368d992c4eafac0; });
$parcel$export(module.exports, "h", function () { return $36f917fbf2efdd6b$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "q", function () { return $36f917fbf2efdd6b$export$9e5f44173e64f162; });
$parcel$export(module.exports, "s", function () { return $36f917fbf2efdd6b$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "p", function () { return $36f917fbf2efdd6b$export$ffb5f4729a158638; });
$parcel$export(module.exports, "e", function () { return $36f917fbf2efdd6b$export$f1e1789686576879; });
$parcel$export(module.exports, "c", function () { return $36f917fbf2efdd6b$export$db3b6bfb95261072; });
$parcel$export(module.exports, "o", function () { return $36f917fbf2efdd6b$export$ae1af26003f05816; });
$parcel$export(module.exports, "m", function () { return $36f917fbf2efdd6b$export$953cecd6e717a553; });
$parcel$export(module.exports, "l", function () { return $36f917fbf2efdd6b$export$882b5998b3b9117c; });
$parcel$export(module.exports, "g", function () { return $36f917fbf2efdd6b$export$39b482c5e57630a8; });
$parcel$export(module.exports, "a", function () { return $36f917fbf2efdd6b$export$407448d2b89b1813; });
$parcel$export(module.exports, "f", function () { return $36f917fbf2efdd6b$export$2d1720544b23b823; });

var $ect5N = parcelRequire("ect5N");

var $aYXpI = parcelRequire("aYXpI");

var $keBYm = parcelRequire("keBYm");
function $36f917fbf2efdd6b$export$43caf9889c228507(obj) {
    var object = obj;
    Object.keys(object).forEach(function(key) {
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $36f917fbf2efdd6b$export$4368d992c4eafac0() {
    return Date.now();
}
function $36f917fbf2efdd6b$var$getComputedStyle(el) {
    var window1 = (0, $keBYm.a)();
    var style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $36f917fbf2efdd6b$export$dda1d9f60106f0e9(el, axis) {
    if (axis === void 0) axis = "x";
    var window1 = (0, $keBYm.a)();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = $36f917fbf2efdd6b$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map(function(a) {
            return a.replace(",", ".");
        }).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $36f917fbf2efdd6b$export$35e795649ee09318(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $36f917fbf2efdd6b$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $36f917fbf2efdd6b$export$9e5f44173e64f162() {
    var _loop = function(i) {
        var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$36f917fbf2efdd6b$var$isNode(nextSource)) {
            var keysArray = Object.keys(Object(nextSource)).filter(function(key) {
                return noExtend.indexOf(key) < 0;
            });
            for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                var nextKey = keysArray[nextIndex];
                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($36f917fbf2efdd6b$export$35e795649ee09318(to[nextKey]) && $36f917fbf2efdd6b$export$35e795649ee09318(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $36f917fbf2efdd6b$export$9e5f44173e64f162(to[nextKey], nextSource[nextKey]);
                    } else if (!$36f917fbf2efdd6b$export$35e795649ee09318(to[nextKey]) && $36f917fbf2efdd6b$export$35e795649ee09318(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $36f917fbf2efdd6b$export$9e5f44173e64f162(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    };
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    var noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(var i = 1; i < arguments.length; i += 1)_loop(i);
    return to;
}
function $36f917fbf2efdd6b$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $36f917fbf2efdd6b$export$ffb5f4729a158638(_ref) {
    var swiper = _ref.swiper, targetPosition = _ref.targetPosition, side = _ref.side;
    var window1 = (0, $keBYm.a)();
    var startPosition = -swiper.translate;
    var startTime = null;
    var time;
    var duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    var dir = targetPosition > startPosition ? "next" : "prev";
    var isOutOfBound = function(current, target) {
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    var animate = function() {
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo((0, $ect5N._)({}, side, currentPosition));
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(function() {
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo((0, $ect5N._)({}, side, currentPosition));
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $36f917fbf2efdd6b$export$342063e11d6c3cad(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function $36f917fbf2efdd6b$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = "";
    return (0, $aYXpI._)(element.children).filter(function(el) {
        return el.matches(selector);
    });
}
function $36f917fbf2efdd6b$export$db3b6bfb95261072(tag, classes) {
    var _el_classList;
    if (classes === void 0) classes = [];
    var el = document.createElement(tag);
    (_el_classList = el.classList).add.apply(_el_classList, (0, $aYXpI._)(Array.isArray(classes) ? classes : [
        classes
    ]));
    return el;
}
function $36f917fbf2efdd6b$export$8b22cf2602fb60ce(el) {
    var window1 = (0, $keBYm.a)();
    var document1 = (0, $keBYm.g)();
    var box = el.getBoundingClientRect();
    var body = document1.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    var scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $36f917fbf2efdd6b$export$ae1af26003f05816(el, selector) {
    var prevEls = [];
    while(el.previousElementSibling){
        var prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $36f917fbf2efdd6b$export$953cecd6e717a553(el, selector) {
    var nextEls = [];
    while(el.nextElementSibling){
        var next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $36f917fbf2efdd6b$export$882b5998b3b9117c(el, prop) {
    var window1 = (0, $keBYm.a)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $36f917fbf2efdd6b$export$39b482c5e57630a8(el) {
    var child = el;
    var i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $36f917fbf2efdd6b$export$407448d2b89b1813(el, selector) {
    var parents = []; // eslint-disable-line
    var parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $36f917fbf2efdd6b$export$23f2a1d2818174ef(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $36f917fbf2efdd6b$export$2d1720544b23b823(el, size, includeMargins) {
    var window1 = (0, $keBYm.a)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}

});



parcelRequire.register("aqSZJ", function(module, exports) {

$parcel$export(module.exports, "fundList", function () { return $7986fde4dbb5bfb1$export$9a67be96d773b168; });

var $eaKPP = parcelRequire("eaKPP");

var $2E0rM = parcelRequire("2E0rM");

var $3ylbB = parcelRequire("3ylbB");

var $azza6 = parcelRequire("azza6");

var $iVCTc = parcelRequire("iVCTc");

var $8pYpl = parcelRequire("8pYpl");

var $79Cku = parcelRequire("79Cku");

var $geOuy = parcelRequire("geOuy");

var $6V2iD = parcelRequire("6V2iD");

var $igi2w = parcelRequire("igi2w");

var $cPatm = parcelRequire("cPatm");

var $4ASfe = parcelRequire("4ASfe");

var $4pC0f = parcelRequire("4pC0f");

var $czz7l = parcelRequire("czz7l");

var $yULRy = parcelRequire("yULRy");

var $eAihi = parcelRequire("eAihi");

var $7jiN3 = parcelRequire("7jiN3");

var $kuUi5 = parcelRequire("kuUi5");
var $7986fde4dbb5bfb1$export$9a67be96d773b168 = [
    {
        title: "Save the Children",
        url: "https://www.savethechildren.net/what-we-do/emergencies/ukraine-crisis",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($eaKPP))),
        retinaImg: (0, (/*@__PURE__*/$parcel$interopDefault($2E0rM)))
    },
    {
        title: "Project HOPE",
        url: "https://www.projecthope.org/country/ukraine/",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($3ylbB))),
        retinaImg: (0, (/*@__PURE__*/$parcel$interopDefault($azza6)))
    },
    {
        title: "UNITED24",
        url: "https://u24.gov.ua/uk",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($iVCTc))),
        retinaImg: (0, (/*@__PURE__*/$parcel$interopDefault($8pYpl)))
    },
    {
        title: "International Medical Corps",
        url: "https://internationalmedicalcorps.org/country/ukraine/",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($79Cku))),
        retinaImg: (0, (/*@__PURE__*/$parcel$interopDefault($geOuy)))
    },
    {
        title: "Medicins Sans Frontieres",
        url: "https://www.msf.org/ukraine",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($6V2iD))),
        retinaImg: (0, (/*@__PURE__*/$parcel$interopDefault($igi2w)))
    },
    {
        title: "RAZOM",
        url: "https://www.razomforukraine.org/",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($cPatm))),
        retinaImg: (0, (/*@__PURE__*/$parcel$interopDefault($4ASfe)))
    },
    {
        title: "Action against hunger",
        url: "https://www.actionagainsthunger.org/location/europe/ukraine/",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($4pC0f))),
        retinaImg: (0, (/*@__PURE__*/$parcel$interopDefault($czz7l)))
    },
    {
        title: "World vision",
        url: "https://www.wvi.org/emergencies/ukraine",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($yULRy))),
        retinaImg: (0, (/*@__PURE__*/$parcel$interopDefault($eAihi)))
    },
    {
        title: "Serhiy Prytula Charity Foundation",
        url: "https://prytulafoundation.org/en",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($7jiN3))),
        retinaImg: (0, (/*@__PURE__*/$parcel$interopDefault($kuUi5)))
    }
];

});
parcelRequire.register("eaKPP", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("iJ6vb");

});

parcelRequire.register("2E0rM", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("agntg");

});

parcelRequire.register("3ylbB", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("eHUIz");

});

parcelRequire.register("azza6", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("7aCTR");

});

parcelRequire.register("iVCTc", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("c5wfK");

});

parcelRequire.register("8pYpl", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("hJtLD");

});

parcelRequire.register("79Cku", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("7dWzA");

});

parcelRequire.register("geOuy", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("kIVln");

});

parcelRequire.register("6V2iD", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("bUmjK");

});

parcelRequire.register("igi2w", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("tUS9z");

});

parcelRequire.register("cPatm", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("efqG8");

});

parcelRequire.register("4ASfe", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("hDgIJ");

});

parcelRequire.register("4pC0f", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("j1Ya2");

});

parcelRequire.register("czz7l", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("6J1Be");

});

parcelRequire.register("yULRy", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("6z7Ny");

});

parcelRequire.register("eAihi", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("jaW5E");

});

parcelRequire.register("7jiN3", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("lfOYP");

});

parcelRequire.register("kuUi5", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("7Vem4") + (parcelRequire("iE7OH")).resolve("5sMXO");

});



})();
//# sourceMappingURL=shopping-list.6889cc6c.js.map
